import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type UnreadCountOperation = paths['/executor_web/notifications/unread_count']['get'];

export type UnreadNotificationsCountResponse = UnreadCountOperation['responses'][200]['content']['application/json'];

/** GET `/executor_web/notifications/unread_count` — число непрочитанных уведомлений */
export function fetchUnreadNotificationsCount(signal?: AbortSignal) {
	return axiosInstance.get<UnreadNotificationsCountResponse>('notifications/unread_count', {signal});
}
